import React, { useEffect, useState } from 'react';
import "./changepassword.css" ; 
import LockPic from "./../../Images/lock.png" ; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { STATUS } from '../../Constants';
import { useDispatch, useSelector } from 'react-redux';
import { changePasswordAPI, getStateusChangePassword, getToken, logout } from '../../RTK/Slice/Auth/AuthSlice';
import { useTranslation } from 'react-i18next';

const ChangePassword = () => {

  // For Translattion
  const {t} = useTranslation() ; 

  // For Dispatch Action
  const disptach = useDispatch() ; 

  // For Access Old Password Filed
  const [oldPassword , setOldPassword] = useState("") ;
  
  // For Access New Password
  const [newPassword , setNewPassword] = useState('') ;

  // For Accesss Re New Password
  const [reNewPassword , setReNewPassword] = useState("") ;

  // For Match New Password and Confirm Re New Password
  const [match ,setMatch ] = useState(STATUS.IDLE) // IDLE || SUCCESS || ERROR

  // For Get Token
  const token = useSelector(getToken) ; 

  // For Get Status Of Change Password
  const getStatus = useSelector(getStateusChangePassword) ;

  // For Dispatch Action
  const dispatch = useDispatch() ;
  
  // For Handle Re New Password
  const ReNewPasswordHandelr = (e)=>{
      setReNewPassword(e.target.value) ; 
      if(newPassword.length > 0 && e.target.value === newPassword){
        setMatch(STATUS.SUCCESS)
      }else if(e.target.value === "") {
        setMatch(STATUS.IDLE)
      }else{
        setMatch(STATUS.ERROR)
      }
  }

  useEffect(()=>{
    if(newPassword.length > 0 && reNewPassword === newPassword){
      setMatch(STATUS.SUCCESS)
    }else if(reNewPassword === "") {
      setMatch(STATUS.IDLE)
    }else{
      setMatch(STATUS.ERROR)
    }

    if(STATUS.SUCCESS === getStatus)
      {
        dispatch(logout()) ; 
        window.location.reload();
      }

  } , [newPassword , reNewPassword , getStatus])



  // For Change Password Handler
  const changePasswordHandler = (e)=>{
    e.preventDefault() ;
    if(match === STATUS.SUCCESS){
      disptach(changePasswordAPI({token , oldPassword  , newPassword})) ;
    }
  }

  return (
    <section className='change-password-con'>
        <div className='lock-icon'>
          <img src={LockPic} alt='lock' />
        </div>
        <div className='titles'>
          <h2>Change Password</h2>
          <p>To change your password, please fill in the fields belows. </p>
          <p style={{width : "450px"}} >Your password must contain at least 8 character, it must also include at least one upper case letter, one lower case letter ,one number and one spcial character.</p>
        </div>
        <form onSubmit={changePasswordHandler} className='change-form'>

          <div className='row'>
            <label htmlFor='old'>Current Password</label>
            <div className='input-field'>
              <div className='left'>
                <FontAwesomeIcon icon={faLock} />
                <input value={oldPassword} onChange={(e)=>setOldPassword(e.target.value)} id='old' placeholder={"Current Password"} />
              </div>
            </div>
          </div>

          <div className='row'>
            <label htmlFor='new'>New Password</label>
            <div className='input-field'>
              <div className='left'>
                <FontAwesomeIcon icon={faLock} />
                <input value={newPassword} onChange={(e)=>setNewPassword(e.target.value)} id='new' placeholder={"New Password"} />
              </div>
            </div>
          </div>

        <div className='row'>
          <label htmlFor='confimr'>Confirm Password</label>
          <div className='input-field'>
            <div className='left'>
              <FontAwesomeIcon icon={faLock} />
              <input value={reNewPassword} onChange={(e)=>ReNewPasswordHandelr(e)} id='confirm' placeholder={"Confirm Password"} />
            </div>
          </div>
        </div>
        <p className={`err-msg ${match === STATUS.ERROR ? 'err-msg-show' : ""}`}> The Password doesn't match</p>
        

        <button type='submit'  className='submit-btn'>Change Password</button>

        </form>
    </section>
  )
}

export default ChangePassword
